import { useTranslation } from "react-i18next";
import { modalControl, successControl } from "util/commAction";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { lgnPwdChkApi } from "components/api/user";
import PwdReset from "./reset";
import "../userInf.scss";

export default function MailCheck() {
  const { t } = useTranslation();

  const [emlId, setEmlId] = useState("");
  const [lgnPwd, setLgnPwd] = useState("");

  const lgnPwdChkMutation = useMutation({
    mutationFn: lgnPwdChkApi,
    onSuccess: (res) => {
      if (res) {
        successControl({
          status: res.status,
          success: () => {
            modalControl({
              keep: true,
              styles: "w-full max-w-[386px]",
              chckBtn: false,
              inner: <PwdReset emlId={emlId} />,
            });
          },
        });
      }
    },
  });

  // 비밀번호 확인
  const handleResetPwd = () => {
    lgnPwdChkMutation.mutate({
      emlId,
      lgnPwd,
    });
  };

  return (
    <div className="modal-inner">
      <div className="h-[72px]">
        <h3 className="text-center">{t("plchl_pss_chk_cmm")}</h3>
        {/* <h6 className="text-center text-gray-500">{t("ttl_dscrp_md_mpg")}</h6> */}
      </div>
      <form className="pwd-rst-form">
        <input
          type="text"
          name="emlId"
          className="mb-6"
          placeholder={t("plchl_id_cmm")}
          onChange={(e) => {
            setEmlId(e.currentTarget.value);
          }}
        />

        <input
          type="password"
          name="lgnPwdcheck"
          placeholder={t("plchl_pss_chk_cmm")}
          onChange={(e) => {
            setLgnPwd(e.currentTarget.value);
          }}
        />
      </form>
      <div className="center">
        <button
          className="btn w-[100px]"
          disabled={!(emlId && lgnPwd)}
          onClick={handleResetPwd}
        >
          {t("btn_hm_cnf")}
        </button>
      </div>
    </div>
  );
}
